import { render, staticRenderFns } from "./Ingressar.vue?vue&type=template&id=bb457160&scoped=true&lang=pug&"
import script from "./Ingressar.vue?vue&type=script&lang=js&"
export * from "./Ingressar.vue?vue&type=script&lang=js&"
import style0 from "./Ingressar.styl?vue&type=style&index=0&id=bb457160&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb457160",
  null
  
)

export default component.exports